import { UxAsset } from '.';
import VehicleType from '../enums/vehicle-type';
import { FilterGroup } from '../typings';
import { AssetData } from './asset';
import GenericAsset from './generic-asset';

export type AutomobileAssetData = AssetData & {
  make?: string | null;
  model?: string | null;
  year?: string | null;
  condition?: string | null;
};

export default class AutomobileAsset extends GenericAsset<AutomobileAssetData> {
  make: string | null;
  model: string | null;
  year: string | null;
  condition: string | null;

  constructor(data: AutomobileAssetData) {
    super('automobile', VehicleType.AUTOMOBILE, data);
    this.make = data.make !== undefined ? data.make : null;
    this.model = data.model !== undefined ? data.model : null;
    this.year = data.year !== undefined ? data.year : null;
    this.condition = data.condition !== undefined ? data.condition : null;
  }

  /**
   * Temporary Hack to disable filtering for CTAs on domains/partners
   * using AutomobileAsset.
   * TODO: This should be removed once we implement proper segmentation
   * for global filter rules.
   */
  filterCTA(_filterGroups: FilterGroup[]): boolean {
    return false;
  }

  /**
   * Convert a AutomobileAsset to the fields the UX server expects
   */
  toUxServer(): UxAsset {
    return {
      ...super.toUxServer(),
      product_id: null,
      product_vin: null,
      product_stock_number: null,
      product_category: null,
      product_subcategory: null,
      product_make: this.make?.toString() || null,
      product_model: this.model?.toString() || null,
      product_year: this.year?.toString() || null,
      product_color: null,
      product_condition: this.condition?.toString() || null,
      product_on_sale: false,
      product_location: null,
      product_dealer_id: null,
      product_ad_id: null,
      product_vehicle_type: this.vehicleType
    };
  }
}
